// src/components/ProtectedHome.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import LoginHome from "../private/Home";
import verifytoken from "../../env/verifytoken";
import { toast } from "react-toastify";
import { config } from "../../utils/config";
import { getSubscriptionStatus } from "../../utils/helper";
import { useDispatch } from "react-redux";
import KEYS from "../../env/env";
import { setPlanDetails } from "../../redux/slices/PlanDetailSlice";

function ProtectedHome({ store }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [showVariationCountPopup, setShowVariationCountPopup] = useState(false);
  const [variationCountLeft, setVariationCountLeft] = useState(0);

  const token = localStorage.getItem("Login");
  const isValidToken = token && !verifytoken();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callUserDataApi = async (token, email) => {
    try {
      setLoading(true);
      let data = {
        email: email,
      };
      let response = await fetch(KEYS.apiPath + "user/data", {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      let val = await response.json();
      // console.log("val?.response?.user", val?.response?.user);
      if (+val.resultFlag === 1) {
        let user = val?.response?.user;
        // secureLocalStorage.setItem("Login", val?.response?.token);
        let userDetails = val?.response?.user;
        let userPlanDetails = val?.response?.userPlan;
        let variants = val?.response?.variants;

        localStorage.setItem(
          config.USER_LOGIN_DETAILS,
          JSON.stringify(userDetails)
        );
        localStorage.setItem(
          config.USER_PLAN_DETAILS,
          JSON.stringify(userPlanDetails)
        );
        if (variants) {
          localStorage.setItem(config.VARIANT_COUNT, JSON.stringify(variants));
          dispatch(setPlanDetails({ userPlanDetails: userPlanDetails }));
        }
        //  console.log("going to redirect to home");
      }
    } catch (e) {
      toast.error(`Error in getting user details: ${e}`);
    } finally {
      setLoading(false);
    }
  };

  const handleUserRedirection = async () => {
    const token = localStorage.getItem("Login");

    // Case 1: Magic link / invite with token + email in URL
    if (queryParams.get("token") && queryParams.get("email")) {
      const inviteToken = queryParams.get("token");
      const email = queryParams.get("email");
      const isNewUser = queryParams.get("isNewUser") === "true";

      localStorage.setItem("Login", inviteToken);
      // optional: localStorage.setItem("token", inviteToken); // if you still need separate "token"

      try {
        await callUserDataApi(inviteToken, email);
      } catch (err) {
        console.error("Failed to fetch user data after invite", err);
        toast.error(
          "Failed to load user data. Please try logging in normally."
        );
        navigate("/Login", { replace: true });
        return;
      }

      // Redirect based on new/existing user
      if (isNewUser) {
        navigate("/plans", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
      return; // stop further checks
    }

    // Case 2: No token at all → go to login
    if (!token) {
      navigate("/Login", { replace: true });
      return;
    }

    // Case 3: Token exists → validate it
    const isTokenExpired = verifytoken(); // true = expired / invalid

    // Optional: clear sensitive data when logging out / token invalid
    if (isTokenExpired) {
      localStorage.removeItem("Login");
      localStorage.removeItem(config.USER_LOGIN_DETAILS);
      localStorage.removeItem(config.USER_PLAN_DETAILS);
      localStorage.removeItem(config.VARIANT_COUNT);
      navigate("/Login", { replace: true });
    }

    // Case 4: Valid token → check plan/subscription status → show popup if needed
    let planDetails = null;

    const userPlanRaw = localStorage.getItem(config.USER_PLAN_DETAILS);

    if (userPlanRaw && userPlanRaw !== "undefined" && userPlanRaw !== "null") {
      try {
        const parsed = JSON.parse(userPlanRaw);

        if (Array.isArray(parsed)) {
          planDetails = parsed[0] || null;
        } else if (typeof parsed === "object" && parsed !== null) {
          planDetails = parsed;
        }
      } catch (err) {
        console.error("Failed to parse user plan details:", err);
      }
    }

    if (planDetails) {
      if ([1, 5].includes(+planDetails.plan_id)) {
        const total = parseInt(planDetails.total_variant || 0, 10);
        const downloaded = parseInt(planDetails.variant_count || 0, 10);
        const remaining = total - downloaded;

        setShowVariationCountPopup(remaining < 4);
      } else {
        const status = getSubscriptionStatus(planDetails);
        setShowVariationCountPopup(status === "Subscription expired");
      }
    } else {
      console.warn("No valid plan details found in localStorage");
      setShowVariationCountPopup(false);
    }

    // Optional: update variation count if you still need it
    const variantRaw = localStorage.getItem(config.VARIANT_COUNT);
    if (variantRaw && variantRaw !== "undefined" && variantRaw !== "null") {
      try {
        const variantData = JSON.parse(variantRaw);
        setVariationCountLeft(variantData?.remaning || 0);
      } catch (err) {
        console.error("Failed to parse variant count:", err);
      }
    }
  };

  useEffect(() => {
    if (!isValidToken) {
      navigate("/Login", { replace: true });
    }
  }, [isValidToken, navigate]);

  useEffect(() => {
    handleUserRedirection();
  }, [token]);

  if (!isValidToken) {
    return null;
  }

  return <LoginHome store={store} />;
}

export default ProtectedHome;
